/**
 * 逻辑商品「通道行齐备」判据（dev-docs `03-数据字典/70-产品配置.md` §2「多通道行但非多份手算」，dev-docs#1519）。
 *
 * 通道行齐备 = 一条 IAP 行 + 至少一条非 IAP 通道行：STRIPE 行恒算；已登记框架通道行只在 `CONSUMABLE` 时算
 * （与 §2.5「卡位参与通道」同口径，框架通道只售一次性商品）。不要求为该 App 未使用的结算通道建行，
 * 故 IAP + PAYERMAX 的一次性商品已齐备，不再被报成「缺 STRIPE」。
 *
 * 纯函数，不读库；归组（按 `access_level_id`）与行来源由调用方决定。
 */

import { isFrameworkSettlementChannel } from './payment-methods';

/** 缺失项闭集：缺 IAP 行 / 缺任何可计入的非 IAP 通道行。 */
export const CHANNEL_ROW_GAPS = ['IAP', 'NON_IAP'] as const;
export type ChannelRowGap = (typeof CHANNEL_ROW_GAPS)[number];

export type ChannelRowCompletenessInput = {
  paymentMethod: string;
  productType: string;
};

/** 该行能否计作「非 IAP 通道行」：STRIPE 恒可；框架通道只计 CONSUMABLE；闭集外取值不计。 */
function countsAsNonIapRow(row: ChannelRowCompletenessInput): boolean {
  if (row.paymentMethod === 'STRIPE') return true;
  return isFrameworkSettlementChannel(row.paymentMethod) && row.productType === 'CONSUMABLE';
}

/** 返回同一逻辑商品（一组未软删行）缺的项，按 `CHANNEL_ROW_GAPS` 顺序；齐备时为空数组。 */
export function channelRowGapsOf(rows: readonly ChannelRowCompletenessInput[]): ChannelRowGap[] {
  const gaps: ChannelRowGap[] = [];
  if (!rows.some((row) => row.paymentMethod === 'IAP')) gaps.push('IAP');
  if (!rows.some(countsAsNonIapRow)) gaps.push('NON_IAP');
  return gaps;
}
